export const createElement = <T extends HTMLElement>(
    tag: string,
    text?: string,
    properties?: Record<string, string>
) => {
    const element = <T>document.createElement(tag);

    if (text) element.textContent = text;
    if (properties) {
        Object.entries(properties)?.forEach(([attribute, value]) =>
            element.setAttribute(attribute, value)
        );
    }

    return element;
};
